export const action = async (e, ctx) => {
  const addToCart = e.target;
  e.preventDefault();

  if (!addToCart) {
    return;
  }

  const variantSelectorElement = addToCart.closest(
    "[data-product-current-variant-id]"
  );

  if (
    !variantSelectorElement ||
    !variantSelectorElement.dataset?.productCurrentVariantId
  ) {
    return;
  }

  try {
    const { store } = await import(
      "../../../../../src/scripts/vue/config/store"
    );

    try {
      const cart = await store.dispatch("cart/addToCart", [
        {
          id: parseInt(variantSelectorElement.dataset.productCurrentVariantId),
          quantity: 1,
          properties: {
            _created_at: Date.now(),
          },
        },
      ]);

      if (cart) {
        store.dispatch("cart/toggleCart");
      }
    } catch (error) {
      console.error(error);
    }
  } catch (e) {
    console.error(e);
  }
};
